export default "__VITE_ASSET__CdSENykR__"